export const SUCCESS_NOTIFICATION_EVENT = 'bskt:success-notification';
export type NotificationTone = 'success' | 'error' | 'warning' | 'info';
const showNotification = (message: string, title: string, tone: NotificationTone) =>
    window.dispatchEvent(new CustomEvent(SUCCESS_NOTIFICATION_EVENT, {detail:{message,title,tone}}));


export const NotifyHelper = {
    //https://react-hot-toast.com/docs/toast
    Success: (message: string, title?: string) => {
        const text=message.toLocaleLowerCase('vi-VN');
        const heading=title || (text.includes('xóa')?'Xóa thành công':text.includes('cập nhật')||text.includes('sửa')?'Cập nhật thành công':text.includes('thêm')?'Thêm mới thành công':'Thành công');
        return showNotification(message, heading, 'success');
    },
    Error: (message?: string, title = 'Không thể hoàn tất') => showNotification(message ?? 'Đã xảy ra lỗi. Vui lòng thử lại.', title, 'error'),
    Warning: (message: string, title = 'Cần kiểm tra') => showNotification(message, title, 'warning'),
    Info: (message: string, title = 'Thông báo') => showNotification(message, title, 'info')
}
